import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
  padding: 1rem 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid ${theme.colors.gray.Cinza_11};

  &:last-child {
    border-bottom: none;
  }
`;

export const FieldValue = styled.p`
  font-family: "Lato", sans-serif;
  font-size: 0.875rem;
  line-height: 1.4;
  color: ${theme.colors.gray.Cinza_5};
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const Empty = styled.div`
  padding: 2rem 1.5rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
`;

export const EmptyText = styled.p`
  font-family: "Lato", sans-serif;
  font-size: 0.875rem;
  color: ${theme.colors.gray.Cinza_7};
  font-style: italic;
  margin: 0;
`;

export const CenterLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
`;

